import api from "@/lib/api";

// Emite un evento a nuestra tabla `eventos`. Nunca rompe la UI si falla (usuario sin sesión, red, etc.).
export function track(tipo, contexto = {}) {
  if (!tipo) return;
  try {
    api.post("/eventos", { tipo, contexto }).catch(() => {});
  } catch {
    /* noop */
  }
}

export default track;
